import { Link } from "react-router-dom";
import { SITE } from "@/config/site";

export default function CtaBand({ stats }: { stats: { id: string; value: string; label: string }[] }) {
  return (
    <section className="bg-foreground-950">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-foreground-950">
              <i className="ri-store-3-line"></i> For business owners
            </span>
            <h2 className="font-heading text-2xl font-extrabold leading-tight text-background-50 md:text-4xl">
              Own a business in {SITE.regions[0]}? Get found.
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-200 md:text-base">
              Join thousands of local businesses on the directory. Create a free listing in minutes,
              then upgrade for a verified badge, priority placement and homepage features.
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <Link
                to="/list-your-business"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-bold text-foreground-950 transition-colors hover:bg-primary-400 cursor-pointer"
              >
                <i className="ri-add-circle-line"></i> Add your Business
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/10 px-5 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 cursor-pointer"
              >
                <i className="ri-customer-service-2-line"></i> Talk to our team
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {stats.map((s) => (
              <div
                key={s.id}
                className="flex flex-col items-center gap-1 rounded-lg border border-background-50/15 bg-background-50/5 px-4 py-6 text-center backdrop-blur"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-foreground-950">
                  <i className="ri-line-chart-line text-base"></i>
                </span>
                <span className="mt-2 font-heading text-2xl font-extrabold text-background-50 md:text-3xl">{s.value}</span>
                <span className="text-xs text-background-200">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}